import { useBreakpointValue } from '@chakra-ui/react';

export const useIsMobile = (targetResolution: 'sm' | 'md' | 'lg' = 'sm') => {
  return useBreakpointValue({ base: true, [targetResolution]: false }, { ssr: false });
};
